import { AppVersion } from '51trips-frontend-core'

const appVersionConverter = (appVersionData: string) => {
  if (typeof appVersionData === 'string') {
    const numberSeparatedAppVersion = appVersionData
      .split('.')
      .map((versionValue) => +versionValue)
      .filter((versionValue) => !isNaN(versionValue))

    if (numberSeparatedAppVersion.length >= 3) {
      return new AppVersion(
        numberSeparatedAppVersion[0],
        numberSeparatedAppVersion[1],
        numberSeparatedAppVersion[2]
      )
    }
  }
}

export default appVersionConverter
